/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Laravel
 * OpenAPI spec version: 0.0.1
 */

/**
 * Deliberately general, not Meeting- or Portfolio-specific: the values match the subset of `portfolio_task_questions.type` that Conversations share. Portfolio keeps its own, wider list (`star_rating`, `checkbox`; see `PortfolioTaskQuestion::TYPES_WITH_OPTIONS` and `questionType.constants.ts`) and does not use this enum.
 */
export type QuestionType = typeof QuestionType[keyof typeof QuestionType];


export const QuestionType = {
  single_line: 'single_line',
  multi_line: 'multi_line',
  radio: 'radio',
} as const;
